import React, {useContext} from 'react';
import Header from './Results/Header';
import ActiveFilters, {useHasActiveFilters} from './Common/ActiveFilters';
import {AppContext} from '../contexts/AppContext';
import {translate} from '../helpers/base';
import List from './Results/List';
import Map from './Results/Map';

const Results = () => {

    const {
        isLoading,
        showMap,
        isMobile,
        filteredResults
    } = useContext(AppContext);

    const hasActiveFilters = useHasActiveFilters();

    if (!isLoading && filteredResults.length === 0) {
        return (
            <div className="accommodation-overview--results">
                <div className="accommodation-overview--results-meta no-results">
                    <span>{translate('accommodation-overview.noResults.header')}</span>
                </div>
                <div className="accommodation-overview--results-noresults">
                    <p>{translate('accommodation-overview.noResults.message')}</p>
                    {hasActiveFilters && (
                        <p>{translate('accommodation-overview.noResults.removeFilters')}: <ActiveFilters/></p>
                    )}
                </div>
            </div>
        );
    }

    if (isMobile && showMap) {
        return <Map/>;
    }

    return (
        <div className="accommodation-overview--results">
            {!isLoading && <div className="accommodation-overview--results-meta">
                <Header/>
            </div>}
            {showMap ? <Map/> : <List/>}
        </div>
    );
};

export default Results;
